import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { queryKeys } from "../queryKeys";
import { portalApiClient } from "../apiClient";
import { apiUrls } from "src/consts/ApiUrls";
import { FileType, SasFileResult } from "src/types/InspectionUpdateRequest";
import axios from "axios";

export function useFilesForCompanyId() {
  const { companyId } = useParams();
  const query = useQuery<SasFileResult[]>({
    queryKey: queryKeys.files(companyId!, "all"),
    queryFn: async () => {
      const data = await portalApiClient.get(apiUrls.file.list.url(companyId!));
      if (process.env.VITE_NODE_ENV === "debug") {
        return [
          {
            id: 1,
            files: [""],
            comment: "Fordonskontroll",
            boundingBox: "",
            exif: "",
            fileName: "schema.json",
            deviationId: "",
            companyId: 6,
            depiction: "",
            webUrl:
              "https://stdlspoc001.blob.core.windows.net/apps/schema.json?sv=2023-11-03&st=2025-12-20T17%3A11%3A13Z&se=2030-12-21T17%3A11%3A00Z&sr=b&sp=r&sig=ZzezLW%2FlPTFiAS2%2Brk2dpqoW7NlOcRD9SfROpgjnpd0%3D",
            fileType: FileType.Schema,
          },
        ];
      }
      return data.data;
    },
  });
  return query;
}

export function useFiles(itemID, enabled = true) {
  const { companyId, inspectionId, deviationId } = useParams();
  const queryClient = useQueryClient();
  const { data: companyFiles } = useFilesForCompanyId();
  const query = useQuery<SasFileResult[]>({
    queryKey: queryKeys.files(companyId!, Number(itemID)),
    queryFn: async () => {
      if (itemID && companyFiles) {
        const idFiles = companyFiles.filter(
          (f) => f.deviationId === Number(itemID)
        );
        
        return idFiles;
      } else return [];
    },
    enabled,
  });

  return {
    ...query,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.files(companyId!),
      }),
  };
}

export function useDeleteFile(fileId: number) {
  const query = useMutation({
    mutationFn: async () => {
      await portalApiClient.delete(apiUrls.file.delete.url(fileId));
    },
  });
  return query;
}
